import axios from 'axios';
import Vue from 'vue';
import store from '@/store';
import router from '../router';

// 全局错误消息去重机制
let lastErrorMessage = '';
let lastErrorTime = 0;
const ERROR_MESSAGE_INTERVAL = 1500; // 1秒内相同错误不重复显示

// 显示错误消息（带去重）
function showErrorMessage(message) {
  const now = Date.now();
  if (message === lastErrorMessage && now - lastErrorTime < ERROR_MESSAGE_INTERVAL) {
    return false; // 重复消息，不显示
  }
  lastErrorMessage = message;
  lastErrorTime = now;
  return true;
}

console.log(process,'process.env.API_ROOT')
const service = axios.create({
  baseURL: process.env.API_ROOT,
  withCredentials: true,
  timeout: 1200000,
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    const isToken = (config.headers || {}).isToken === false;
    const token = store.state.user.Authorization;
    if (token && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 文件流直接返回
    if (response.config.responseType === 'blob') {
      return response;
    }
    const { status, data } = response;

    // 登录过期
     if (data && (data.code == 401 || data.code == 424)) {
       // 这里只调用handleLogout，不额外显示消息
       handleLogout(data.msg || '登录已过期');
       return Promise.reject(new Error(''));
     }

    // 业务错误
    if (data && data.code && data.code != 200) {
      console.log(data,'+++++++')
      const errorMsg = data.msg || '请求失败，请稍后重试';
      if (showErrorMessage(errorMsg)) {
        Vue.prototype.$message.error(errorMsg);
      }
      return Promise.reject(new Error(errorMsg));
    }

    if (status == 200) {
      return data;
    } else {
      Vue.prototype.$message.error('请求失败，请稍后重试');
      return Promise.reject(new Error('请求失败'));
    }
  },
  error => {
    const errRes = error.response;
    // 防止重复显示错误消息
    if (errRes) {
      // 登录过期或无权限 - 由handleLogout统一处理
       if (errRes.status == 401 || errRes.status == 424) {
         // 这里只调用handleLogout，不额外显示消息
         handleLogout(errRes.data.msg || '登录超时或账号在另一地点登录，请重新登录');
         // 统一抛出空错误，避免上层重复弹窗或显示Axios默认提示
        //  const silentError = new Error('');
        //  silentError.silent = true;
         return Promise.reject('');
       }
      // 针对504网关超时的特殊处理
      if ((errRes.status == 504||errRes.status == 500||errRes.status == 502) && !isLogout) {
        if (showErrorMessage(errRes.data.msg||'请求失败，请稍后重试')) {
          Vue.prototype.$message.error(errRes.data.msg||'请求失败，请稍后重试');
        }
        return Promise.reject(error);
      }
      // 其他业务错误信息 - 仅在非登录错误时显示
      if (errRes.data && errRes.data.msg && !isLogout) {
        // 只有当showErrorMessage返回true（不是重复消息）时才显示
        if (showErrorMessage(errRes.data.msg)) {
          Vue.prototype.$message.error(errRes.data.msg);
        }
      }
    } else {
      // 网络断开或其他未知错误
      if (!window.navigator.onLine) {
        if (showErrorMessage('网络已断开，请检查您的网络连接')) {
          Vue.prototype.$message.error('网络已断开，请检查您的网络连接');
        }
      } else if (!isLogout) {
        // 其他错误
        if (showErrorMessage('请求异常，请稍后重试')) {
          Vue.prototype.$message.error('请求异常，请稍后重试');
        }
      }
    }
    return Promise.reject(error);
  }
);

// 统一处理登出逻辑
let isLogout = false;
function handleLogout(msg) {
  if (isLogout) return;
  isLogout = true;
  
  // 重置错误消息记录
  lastErrorMessage = '';
  lastErrorTime = 0;
  
  // 关闭所有现有消息
  Vue.prototype.$message.closeAll();
  
  // 即使是登出消息也需要去重，避免424错误显示两次
   if (showErrorMessage(msg)) {
     Vue.prototype.$message.error(msg);
   }
  
  // 执行登出操作
  store.dispatch('Logout').then(() => {
    // 只在当前路由不是 /login 时跳转
    if (router.currentRoute.path !== '/login') {
      router.replace({ path: '/login' });
    }
    // 重置登出状态
    isLogout = false;
  });
}

export default service;



// WEBPACK FOOTER //
// ./src/util/request.js